export default __webpack_public_path__ + "9e924ceeb25ed60e9cbc3bf9da14a725.jpg";